import Vue from "vue";
import format from "date-fns/format";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";
import moment from "moment-timezone";

/* eslint-disable no-magic-numbers */
Vue.filter( "normalizeDate", ( date, formatType = "YYYY-MM-DD" ) => format( date, formatType ) );
Vue.filter( "normalizeDuration", ( secs, _format = "HH:MM:SS", minuteCeiling = true ) => {
    const sec_num = parseInt( secs, 10 );
    const hours = Math.floor( sec_num / 3600 ) % 24;
    let minutes = sec_num / 60;
    minutes = minuteCeiling ? Math.ceil( minutes ) : Math.floor( minutes );
    minutes %= 60;
    const seconds = sec_num % 60;
    if ( _format === "HH" ) {
        return hours < 10 ? `0${ hours}` : hours;
    } else if ( _format === "MM" ) {
        return `${hours > 0 ? hours : "" }:${ minutes < 10 ? `0${ minutes}` : minutes}`;
    } else if ( _format === "SS" ) {
        return seconds < 10 ? `0${ seconds}` : seconds;
    }
    return [ hours, minutes, seconds, ].map( v => ( v < 10 ? `0${ v}` : v ) ).join( ":" );
} );
Vue.filter( "normalizeDurationMinutes", minutes => {
    const hours = Math.floor( minutes / 60 );
    const minStr = ( minutes % 60 ).toString();
    return `${hours}:${minStr.padStart( 2, "0" )}`;
} );
Vue.filter( "relativeTimes", date => {
    return distanceInWordsToNow( date );
} );
Vue.filter( "momentFormat", ( date, outputFormat = "YYYY-MM-DD", timezone = "", inputFormat = "" ) => {
	if ( timezone ) {
		if ( inputFormat ) {
			return moment.tz( date, inputFormat, timezone ).format( outputFormat );
		}
		return moment.tz( date, timezone ).format( outputFormat );
	}
	if ( inputFormat ) {
		return moment( date, inputFormat ).format( outputFormat );
	}
	return moment( date ).format( outputFormat );
} );
Vue.filter( "momentFromNow", ( date, { inputFormat = "", constrainToPast = false, timezone = "", } = {} ) => {
	if ( timezone ) {
		if ( inputFormat ) {
			return moment.tz( date, inputFormat, timezone ).fromNow();
		}
		if ( constrainToPast && Math.abs( moment.tz( new Date(), timezone ).diff( date ) ) < 25000 ) { // 25 seconds before or after date
			return "just now";
		}
		return moment.tz( date, timezone ).fromNow();
	}
	if ( inputFormat ) {
		return moment( date, inputFormat ).fromNow();
	}
	if ( constrainToPast && Math.abs( moment().diff( date ) ) < 25000 ) { // 25 seconds before or after date
        return "just now";
    }
	return moment( date ).fromNow();
} );
/* eslint-enable no-magic-numbers */



// WEBPACK FOOTER //
// ./src/filters/date.js